"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncludeMetrics = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var tooltipAlignPoints = [
    { align: "cr cl", offset: { x: 0, y: 0 } },
    { align: "cl cr", offset: { x: 0, y: -2 } },
];
function IncludeMetrics(props) {
    var value = props.value, onChange = props.onChange;
    var intl = react_intl_1.useIntl();
    return (react_1.default.createElement("div", { className: "include-metrics-wrapper" },
        react_1.default.createElement(sdk_ui_kit_1.Checkbox, { onChange: onChange, value: value, text: intl.formatMessage({ id: "configurationPanel.visualprops.includeMetrics" }), labelSize: "small" }),
        react_1.default.createElement(sdk_ui_kit_1.BubbleHoverTrigger, { tagName: "div", showDelay: 200, hideDelay: 0 },
            react_1.default.createElement("span", { className: "gd-icon-circle-question" }),
            react_1.default.createElement(sdk_ui_kit_1.Bubble, { className: "bubble-primary", alignPoints: tooltipAlignPoints, arrowOffsets: { "cr cl": [15, 0] } }, intl.formatMessage({ id: "configurationPanel.visualprops.includeMetricsHelp" })))));
}
exports.IncludeMetrics = IncludeMetrics;
//# sourceMappingURL=IncludeMetrics.js.map